module.exports = __webpack_public_path__ + "media/images/contacto/skype-7bee018b8b18235a0e7cab068edaf5cb.svg";